module.exports = __webpack_public_path__ + "img/bg-1.06723051.png";